// ─────────────────────────────────────────────
//  PwaInstallSheet.jsx — Instrucciones para instalar la PWA
// ─────────────────────────────────────────────

import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './PwaInstallSheet.module.css';
import { INSTALL_PLATFORMS } from './pwaInstallSteps';

export default function PwaInstallSheet({ open, onClose }) {
	useEffect(() => {
		if (!open) return undefined;

		const onKeyDown = (e) => {
			if (e.key === 'Escape') onClose();
		};

		document.body.style.overflow = 'hidden';
		window.addEventListener('keydown', onKeyDown);

		return () => {
			document.body.style.overflow = '';
			window.removeEventListener('keydown', onKeyDown);
		};
	}, [open, onClose]);

	if (!open) return null;

	return createPortal(
		<div
			className={styles.overlay}
			role="dialog"
			aria-modal="true"
			aria-label="Cómo instalar AR Cuánto"
			onClick={onClose}
		>
			<div
				className={styles.sheet}
				onClick={(e) => e.stopPropagation()}
			>
				<header className={styles.header}>
					<h2 className={styles.title}>Instalar AR Cuánto</h2>
					<button
						type="button"
						className={styles.closeBtn}
						onClick={onClose}
						aria-label="Cerrar"
					>
						✕
					</button>
				</header>

				<p className={styles.intro}>
					Instálala en tu pantalla de inicio para usarla como app: pantalla completa,
					acceso rápido y funcionamiento offline.
				</p>

				<div className={styles.platforms}>
					{INSTALL_PLATFORMS.map((platform) => (
						<section key={platform.id} className={styles.platform}>
							<h3 className={styles.platformTitle}>
								<span aria-hidden="true">{platform.icon}</span>
								{platform.title}
							</h3>
							<ol className={styles.steps}>
								{platform.steps.map((step) => (
									<li key={step} className={styles.step}>{step}</li>
								))}
							</ol>
						</section>
					))}
				</div>

				<button
					type="button"
					className={styles.doneBtn}
					onClick={onClose}
				>
					Entendido
				</button>
			</div>
		</div>,
		document.body
	);
}
